import { NgModule } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { FuseSharedModule } from '@fuse/shared.module';

import { MaterialModule } from 'app/main/material.module';

import { DisbandUnitDialogComponent } from './disband-unit-dialog.component'
import { DialogHeaderModule } from 'app/components/dialogs/dialog-header/dialog-header.module';

@NgModule({
    declarations: [
        DisbandUnitDialogComponent,
    ],
    imports: [
        MaterialModule,
        TranslateModule,
        FuseSharedModule,
        DialogHeaderModule,
    ],
    exports: [
        DisbandUnitDialogComponent,
    ]
})

export class DisbandUnitModule
{
}
